import { Route } from '@angular/router';
import { ScheduleDetailsComponent } from 'src/app/pages/network/schedule-details/schedule-details.component';
import { ScheduleEditComponent } from 'src/app/pages/network/schedule-edit/schedule-edit.component';
import { SchedulesComponent } from 'src/app/pages/network/schedules/schedules.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const schedules: Route = {
  path: 'schedules',
  title: 'nav.network.schedules',
  data: {
    breadcrumb: 'nav.network.schedules',
    icon: SbIcons.schedules,
    id: RoutingID.schedules,
  },
  children: [
    {
      path: '',
      component: SchedulesComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'schedule-details/:scheduleID',
      title: 'nav.network.schedules.details',
      data: {
        breadcrumb: 'nav.network.schedules.details',
        icon: SbIcons.details,
        id: RoutingID.scheduleDetails,
      },
      children: [
        {
          path: '',
          component: ScheduleDetailsComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'schedule-create',
      title: 'nav.network.schedules.create',
      data: {
        breadcrumb: 'nav.network.schedules.create',
        icon: SbIcons.plus,
        id: RoutingID.scheduleCreate,
      },
      children: [
        {
          path: '',
          component: ScheduleEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'schedule-edit/:scheduleID',
      title: 'nav.network.schedules.edit',
      data: {
        breadcrumb: 'nav.network.schedules.edit',
        icon: SbIcons.edit,
        id: RoutingID.scheduleEdit,
      },
      children: [
        {
          path: '',
          component: ScheduleEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
